// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__VMAXT","info":"UpdateTermsInfo_info__2j6Xj"};